export default "__VITE_ASSET__DRgSNhL2__"